(() => {
  const init = (root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const trigger = root.querySelector('[data-lmdh-open]');
    const panel = root.querySelector('.lmdh-discovery__panel');
    const backdrop = root.querySelector('.lmdh-discovery__backdrop');
    const input = root.querySelector('[data-lmdh-input]');
    const products = root.querySelector('[data-lmdh-products]');
    const brands = root.querySelector('[data-lmdh-brands]');
    const brandLinks = root.querySelector('[data-lmdh-brand-links]');
    const empty = root.querySelector('[data-lmdh-empty]');
    const all = root.querySelector('[data-lmdh-all]');
    const count = root.querySelector('[data-lmdh-count]');
    const heading = root.querySelector('[data-lmdh-heading]');
    const arrows = root.querySelector('[data-lmdh-arrows]');
    const prev = root.querySelector('[data-lmdh-prev]');
    const next = root.querySelector('[data-lmdh-next]');
    const phoneButton = root.querySelector('[data-lmdh-phone], .lmdh-discovery__empty-btn[href^="tel:"]');
    // Shopify can serve an older Liquid snippet alongside this script.
    // Normalize both layouts so the controls always flank the product row.
    if (arrows && products) {
      let rail = root.querySelector('.lmdh-discovery__rail');
      if (!rail) {
        rail = document.createElement('div');
        rail.className = 'lmdh-discovery__rail';
        products.before(rail);
      }
      rail.append(arrows, products);
    }
    const form = root.querySelector('.lmdh-discovery__form');
    const featured = [...root.querySelectorAll('[data-lmdh-featured] a')].map(el => ({ title: el.dataset.title, vendor: el.dataset.vendor, url: el.href, image: el.dataset.image, price: Number(el.dataset.price) }));
    const fullResults = root.querySelector('[data-lmdh-full-results]');
    const fullGrid = root.querySelector('[data-lmdh-full-grid]');
    const fullPagination = root.querySelector('[data-lmdh-full-pagination]');
    let timer, controller, fullController, lastFocus, collection = '', vendor = '', fullMode = false, lastFullUrl = ''; 
    const currency = new Intl.NumberFormat(root.dataset.locale || 'fr-FR', { style: 'currency', currency: root.dataset.currency || 'EUR' });
    const cleanVendor = (value) => value.replace(/^Marque\s*:\s*/i, '');
    const updateFilters = () => {
      root.querySelectorAll('[data-lmdh-collection]').forEach(el => el.setAttribute('aria-pressed', String(collection === el.dataset.lmdhCollection)));
      root.querySelector('[data-lmdh-reset]').setAttribute('aria-pressed', String(!collection && !vendor));
      brandLinks.querySelectorAll('[data-lmdh-vendor]').forEach(el => el.setAttribute('aria-pressed', String(vendor === el.dataset.lmdhVendor)));
    };
    const open = () => {
      const announcement = document.querySelector('#shopify-section-announcement-bar');
      root.style.setProperty('--lmdh-announcement-height', `${announcement?.getBoundingClientRect().bottom || 0}px`);
      lastFocus = document.activeElement;
      panel.hidden = backdrop.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
      document.body.classList.add('lmdh-discovery-open');
      input.focus();
      if (fullMode) {
        panel.classList.add('lmdh-discovery__panel--full');
        if (!fullGrid.children.length && lastFullUrl) loadFullResults(lastFullUrl);
      } else if (!products.children.length || (products.hidden && !empty.hidden)) search();
    };
    const close = () => {
      clearTimeout(timer);
      controller?.abort();
      fullController?.abort();
      panel.hidden = backdrop.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('lmdh-discovery-open');
      lastFocus?.focus();
    };
    trigger.addEventListener('click', open);
    root.querySelectorAll('[data-lmdh-close]').forEach(el => el.addEventListener('click', close));
    phoneButton?.addEventListener('click', (event) => {
      event.preventDefault();
      const phone = String(phoneButton.dataset.lmdhPhone || phoneButton.getAttribute('href') || '').replace(/^(tel:)/, '').replace(/[^+\d]/g, '');
      if (!phone) return;
      // Trigger the device dialler without navigating the search panel to a blank document when the call is declined.
      const dialler = document.createElement('iframe');
      dialler.hidden = true;
      dialler.setAttribute('aria-hidden', 'true');
      dialler.src = `tel:${phone}`;
      document.body.append(dialler);
      setTimeout(() => dialler.remove(), 1000);
    });
    // Never leave the page scroll-locked: release it when leaving via a result link and when the browser restores this page from its back/forward cache.
    const unlockScroll = () => document.body.classList.remove('lmdh-discovery-open');
    panel.addEventListener('click', (event) => { const a = event.target.closest('a[href]'); if (a && !a.href.startsWith('tel:')) unlockScroll(); });
    window.addEventListener('pagehide', unlockScroll);
    window.addEventListener('pageshow', (event) => { if (event.persisted || panel.hidden) { if (!panel.hidden) close(); unlockScroll(); } });
    root.addEventListener('keydown', (e) => {
      if (panel.hidden) return;
      if (e.key === 'Escape') return close();
      if (e.key === 'Tab') {
        const focusable = [...panel.querySelectorAll('a[href],button:not([disabled]),input,summary')].filter(el => el.getClientRects().length);
        if (!focusable.length) return;
        if (e.shiftKey && document.activeElement === focusable[0]) { e.preventDefault(); focusable[focusable.length - 1].focus(); }
        else if (!e.shiftKey && document.activeElement === focusable[focusable.length - 1]) { e.preventDefault(); focusable[0].focus(); }
      }
    });
    root.querySelectorAll('[data-lmdh-collection]').forEach(el => el.addEventListener('click', () => {
      collection = collection === el.dataset.lmdhCollection ? '' : el.dataset.lmdhCollection;
      // A category click replaces the previous text search instead of combining with it.
      clearTimeout(timer); fullController?.abort();
      input.value = ''; vendor = '';
      fullMode = false; panel.classList.remove('lmdh-discovery__panel--full');
      search();
    }));
    root.querySelector('[data-lmdh-reset]').addEventListener('click', () => { collection = vendor = ''; if (fullMode) fullController?.abort(); search(); });
    brandLinks.addEventListener('click', (event) => {
      const button = event.target.closest('[data-lmdh-vendor]');
      if (!button) return;
      vendor = vendor === button.dataset.lmdhVendor ? '' : button.dataset.lmdhVendor;
      if (fullMode) fullController?.abort();
      search();
    });
    // Shopify renvoie la photo de la variante correspondant au mot tapé : on force la photo principale du produit.
    const mainImageCache = new Map();
    const fetchMainImage = (url) => {
      const path = new URL(url, location.origin).pathname.replace(/\/$/, '');
      const handle = path.split('/products/')[1];
      if (!handle) return Promise.resolve('');
      if (!mainImageCache.has(handle)) {
        mainImageCache.set(handle, fetch(`/products/${handle}.js`).then(r => r.ok ? r.json() : null)
          .then(p => p ? ((p.media || []).find(m => m.media_type === 'image')?.src || p.featured_image || '') : '').catch(() => ''));
      }
      return mainImageCache.get(handle);
    };
    const withMainImage = item => ({ ...item, image: item.featured_image?.url || item.image });
    const applyMainImages = async (items) => Promise.all(items.map(async item => {
      const img = await fetchMainImage(item.url);
      return img ? { ...item, image: img } : item;
    }));
    const render = (items, q, suggestedBrands) => {
      products.scrollLeft = 0;
      fullResults.hidden = true;
      fullPagination.replaceChildren();
      products.replaceChildren();
      if (suggestedBrands !== null) {
        const vendors = [...new Set(suggestedBrands.map(item => item.vendor).filter(Boolean))];
        brandLinks.replaceChildren();
        vendors.forEach(value => {
          const button = document.createElement('button');
          button.type = 'button'; button.className = 'lmdh-discovery__filter';
          button.dataset.lmdhVendor = value;
          button.textContent = cleanVendor(value);
          brandLinks.append(button);
        });
        brands.hidden = !vendors.length;
      }
      updateFilters();
      items.forEach(item => {
        const a = document.createElement('a');
        a.className = 'lmdh-discovery__product';
        a.href = item.url;
        if (item.image) {
          const img = document.createElement('img');
          const imageUrl = new URL(item.image, window.location.origin);
          imageUrl.searchParams.set('width', '360');
          img.src = imageUrl.toString();
          img.alt = item.title;
          img.loading = 'lazy';
          a.append(img);
        }
        const title = document.createElement('span'); title.className = 'lmdh-discovery__product-title'; title.textContent = item.title; a.append(title);
        if (item.price != null) {
          const price = document.createElement('strong'); price.textContent = currency.format(Number(item.price)); a.append(price);
        }
        products.append(a);
      });
      heading.textContent = collection ? (root.querySelector(`[data-lmdh-collection][aria-pressed="true"]`)?.textContent || (root.dataset.resultsHeading || 'Produits correspondants')) : vendor ? cleanVendor(vendor) : q ? (root.dataset.resultsHeading || 'Produits correspondants') : (root.dataset.heading || 'À découvrir');
      count.textContent = (root.dataset.counterText || '{count} produit(s) affiché(s)').replace('{count}', String(items.length));
      empty.hidden = items.length > 0;
      all.hidden = (!q && !collection && !vendor) || items.length === 0;
      const allQuery = vendor ? `vendor:"${cleanVendor(vendor).replace(/"/g, '')}"` : q;
      all.href = collection ? new URL(collection, location.origin).pathname : `${root.dataset.searchUrl}?q=${encodeURIComponent(allQuery)}&type=product&options[unavailable_products]=show`;
      products.hidden = fullMode || items.length === 0;
      if (fullMode) {
        fullGrid.replaceChildren(...[...products.children].map(card => card.cloneNode(true)));
        fullResults.hidden = items.length === 0;
        arrows.hidden = true;
        all.hidden = true;
        return;
      }
      arrows.hidden = items.length < 2;
      requestAnimationFrame(updateArrows);
    };
    const updateArrows = () => {
      prev.disabled = products.scrollLeft <= 2;
      next.disabled = products.scrollLeft + products.clientWidth >= products.scrollWidth - 2;
    };
    products.addEventListener('scroll', updateArrows, { passive: true });
    prev.addEventListener('click', () => products.scrollBy({ left: -products.clientWidth * .8, behavior: 'smooth' }));
    next.addEventListener('click', () => products.scrollBy({ left: products.clientWidth * .8, behavior: 'smooth' }));
    const matches = (item, query) => {
      if (!query) return true;
      const text = [item.title, item.vendor, item.product_type, item.type, item.body, ...(Array.isArray(item.tags) ? item.tags : [])].join(' ').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
      return query.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().split(/\s+/).every(word => text.includes(word));
    };
    const search = async () => {
      controller?.abort(); controller = new AbortController();
      const signal = controller.signal;
      const q = input.value.trim();
      const currentCollection = collection;
      const currentVendor = vendor;
      count.textContent = root.dataset.loadingText || 'Recherche en cours…';
      updateFilters();
      try {
        let items = [], suggestions = null;
        if (currentCollection) {
          const path = new URL(currentCollection, window.location.origin);
          if (path.origin !== window.location.origin || !/^\/collections\/[^/]+\/?$/.test(path.pathname)) throw new Error('Invalid collection');
          // Shopify predictive search cannot filter by collection; use the collection's own product feed.
          // Only scan a bounded preview, and never claim this is a complete result count.
          for (let page = 1; page <= 4 && items.length < 10; page++) {
            const response = await fetch(`${path.pathname.replace(/\/$/, '')}/products.json?limit=250&page=${page}`, { signal });
            if (!response.ok) throw new Error('Collection unavailable');
            const batch = (await response.json()).products || [];
            items.push(...batch.filter(item => matches(item, q) && (!currentVendor || item.vendor === currentVendor)).map(item => ({
              title: item.title, url: `${path.pathname.replace(/\/$/, '')}/products/${item.handle}`, vendor: item.vendor,
              image: item.images?.[0]?.src, price: item.variants?.[0]?.price
            })));
            if (batch.length < 250) break;
          }
          // Some navigation collections only group sub-collections and expose no direct product feed.
          // Fall back to the category label so these filters still return relevant products.
          if (!items.length) {
            const categoryLabel = root.querySelector(`[data-lmdh-collection="${CSS.escape(currentCollection)}"]`)?.textContent?.trim() || '';
            if (categoryLabel) {
              const fallbackUrl = `${root.dataset.suggestUrl}.json?q=${encodeURIComponent(categoryLabel)}&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=show`;
              const fallbackResponse = await fetch(fallbackUrl, { signal });
              if (!fallbackResponse.ok) throw new Error('Category search unavailable');
              items = ((await fallbackResponse.json()).resources?.results?.products || []).filter(item => matches(item, q)).map(withMainImage);
            }
          }
          items = items.slice(0, 10);
          if (!currentVendor) suggestions = items;
        } else {
          if (!q && !currentVendor && featured.length) { render(featured, q, featured); return; }
           const term = q || (currentVendor ? '' : 'platine');
          const expression = currentVendor ? `${term ? `${term} AND ` : ''}vendor:"${cleanVendor(currentVendor).replace(/"/g, '')}"` : term;
          const url = `${root.dataset.suggestUrl}.json?q=${encodeURIComponent(expression)}&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=show`;
          const response = await fetch(url, { signal });
          if (!response.ok) throw new Error('Search unavailable');
          items = ((await response.json()).resources?.results?.products || []).filter(item => matches(item, q)).map(withMainImage);
          // Shopify tolère les fautes de frappe : on ne garde que les produits contenant vraiment les mots tapés.
          if (!currentVendor) suggestions = items;
        }
        items = await applyMainImages(items);
        if (suggestions) suggestions = items;
        if (signal.aborted) return;
        render(items, q, suggestions);
      } catch (error) {
        if (error.name !== 'AbortError') count.textContent = (root.dataset.errorText || 'Recherche momentanément indisponible.') + ' Appuyez sur Entrée pour voir les résultats.';
      }
    };
    const loadFullResults = async (pageUrl) => {
      lastFullUrl = String(pageUrl);
      fullController?.abort(); fullController = new AbortController();
      const signal = fullController.signal;
      count.textContent = root.dataset.loadingText || 'Recherche en cours…';
      fullGrid.replaceChildren(); fullPagination.replaceChildren();
      fullResults.hidden = false;
      products.hidden = true; arrows.hidden = true; all.hidden = true; empty.hidden = true;
      try {
        const url = new URL(pageUrl, location.origin);
        if (url.origin !== location.origin || url.pathname !== root.dataset.searchUrl) throw new Error('Invalid search URL');
        const response = await fetch(url, { signal });
        if (!response.ok) throw new Error('Search unavailable');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        if (signal.aborted) return;
        const cards = [...doc.querySelectorAll('#product-grid > li')];
        cards.forEach(card => {
          const titleLink = card.querySelector('.card-information__text[href]');
          const image = card.querySelector('.card__media img');
          const price = card.querySelector('.price-item--regular, .price-item--sale, .price__regular .price-item');
          if (!titleLink) return;
          const item = document.createElement('a'); item.className = 'lmdh-discovery__product';
          item.href = titleLink.href;
          if (image) {
            const img = document.createElement('img');
            img.src = image.getAttribute('src') || ''; img.alt = image.alt || titleLink.textContent.trim(); img.loading = 'lazy';
            item.append(img);
            fetchMainImage(titleLink.href).then(src => { if (src) { const u = new URL(src, location.origin); u.searchParams.set('width', '360'); img.removeAttribute('srcset'); img.src = u.toString(); } });
          }
          const title = document.createElement('span'); title.className = 'lmdh-discovery__product-title';
          title.textContent = titleLink.textContent.trim(); item.append(title);
          if (price) { const value = document.createElement('strong'); value.textContent = price.textContent.trim(); item.append(value); }
          fullGrid.append(item);
        });
        const total = doc.querySelector('.product-count__text')?.textContent?.trim().match(/\d[\d\s.,]*/)?.[0]?.replace(/\s/g, '');
        count.textContent = (total ? (root.dataset.totalText || '{count} résultats') : (root.dataset.counterText || '{count} produit(s) affiché(s)')).replace('{count}', total || String(fullGrid.children.length));
        heading.textContent = root.dataset.resultsHeading || 'Produits correspondants';
        empty.hidden = fullGrid.children.length > 0;
        fullResults.hidden = fullGrid.children.length === 0;
        doc.querySelectorAll('.pagination__list .pagination__item').forEach(link => {
          if (link.classList.contains('pagination__item--current')) {
            const current = document.createElement('span'); current.className = 'lmdh-discovery__page lmdh-discovery__page--current';
            current.textContent = link.textContent.trim(); current.setAttribute('aria-current', 'page');
            fullPagination.append(current);
            return;
          }
          if (link.tagName !== 'A') return;
          const target = new URL(link.getAttribute('href'), location.origin);
          if (target.pathname !== root.dataset.searchUrl) return;
          const button = document.createElement('button'); button.type = 'button';
          button.className = 'lmdh-discovery__page'; button.textContent = link.textContent.trim();
          button.setAttribute('aria-label', link.getAttribute('aria-label') || button.textContent);
          button.addEventListener('click', () => { loadFullResults(target); panel.scrollTo({ top: 0, behavior: 'smooth' }); });
          fullPagination.append(button);
        });
      } catch (error) {
        if (error.name !== 'AbortError') {
          count.textContent = root.dataset.errorText || 'Recherche momentanément indisponible.';
          fullResults.hidden = true;
          all.hidden = false;
          all.href = `${root.dataset.searchUrl}?q=${encodeURIComponent(input.value.trim())}&type=product&options[unavailable_products]=show`;
        }
      }
    };
    form.addEventListener('submit', (event) => {
      if (!input.value.trim()) { event.preventDefault(); input.focus(); return; }
      event.preventDefault();
      clearTimeout(timer); controller?.abort();
      collection = vendor = ''; updateFilters();
      fullMode = true;
      panel.classList.add('lmdh-discovery__panel--full');
      loadFullResults(`${root.dataset.searchUrl}?q=${encodeURIComponent(input.value.trim())}&type=product&options[unavailable_products]=show`);
    });
    input.addEventListener('input', () => {
      clearTimeout(timer);
      if (collection || vendor) { collection = vendor = ''; updateFilters(); }
      if (fullMode) {
        fullController?.abort();
        timer = setTimeout(() => {
          const q = input.value.trim();
          if (q) loadFullResults(`${root.dataset.searchUrl}?q=${encodeURIComponent(q)}&type=product&options[unavailable_products]=show`);
          else { fullMode = false; panel.classList.remove('lmdh-discovery__panel--full'); search(); }
        }, 300);
      } else timer = setTimeout(search, 250);
    });
    const typed = root.querySelector('[data-lmdh-typed]');
    const text = typed.dataset.texts || '';
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) typed.textContent = text;
    else {
      let i = 0;
      const tick = () => { typed.textContent = text.slice(0, i++); if (i <= text.length) setTimeout(tick, 45); };
      tick();
    }
  };
  const mount = () => document.querySelectorAll('[data-lmdh-search]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount); else mount();
  document.addEventListener('shopify:section:load', mount);
})();
